interface SchemaOrgProps {
  type: "Organization" | "WebSite" | "WebPage" | "Article" | "FAQPage";
  data?: Record<string, unknown>;
  articleData?: {
    headline: string;
    description: string;
    image: string;
    datePublished: string;
    dateModified: string;
    authorName: string;
    url: string;
  };
  faqData?: Array<{ question: string; answer: string }>;
}

export default function SchemaOrg({ type, data, articleData, faqData }: SchemaOrgProps) {
  let schema: Record<string, unknown> = {};

  const baseUrl = "https://baisi-guide.com";

  switch (type) {
    case "Organization":
      schema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "白丝足交完全指南",
        url: baseUrl,
        description: "深入解析白丝足交的感官魅力、技巧要点与互动体验，为成人伴侣提供专业、私密的参考内容。",
        ...(data || {}),
      };
      break;
    case "WebSite":
      schema = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "白丝足交完全指南",
        url: baseUrl,
        description: "深入解析白丝足交的感官魅力、技巧要点与互动体验，为成人伴侣提供专业、私密的参考内容。",
        potentialAction: {
          "@type": "SearchAction",
          target: `${baseUrl}/search?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
        ...(data || {}),
      };
      break;
    case "WebPage":
      schema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        url: baseUrl,
        name: "白丝足交完全指南",
        description: "深入解析白丝足交的感官魅力、技巧要点与互动体验。",
        ...(data || {}),
      };
      break;
    case "Article":
      if (articleData) {
        schema = {
          "@context": "https://schema.org",
          "@type": "Article",
          headline: articleData.headline,
          description: articleData.description,
          image: articleData.image,
          datePublished: articleData.datePublished,
          dateModified: articleData.dateModified,
          author: {
            "@type": "Person",
            name: articleData.authorName,
          },
          publisher: {
            "@type": "Organization",
            name: "白丝足交完全指南",
          },
          url: articleData.url,
          ...(data || {}),
        };
      }
      break;
    case "FAQPage":
      if (faqData && faqData.length > 0) {
        schema = {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqData.map((faq) => ({
            "@type": "Question",
            name: faq.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: faq.answer,
            },
          })),
        };
      }
      break;
  }

  if (Object.keys(schema).length === 0) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}